import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=0f820218"
import script from "./OrderView.vue?vue&type=script&lang=ts"
export * from "./OrderView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports